export default __webpack_public_path__ + "static/media/testImgIlon.e0a9bc34.png";